<template>
  <div>
    <div class="ocr-container">
      <b-form-input type="text" v-model="checklistValue.value" readonly />
      <b-button variant="primary" size="sm" @click="openImageSelection">
        <b-img src="/img/ocr-icon.svg" height="30px" alt="OCR Icon"></b-img>
      </b-button>
      <input
        type="file"
        ref="fileInput"
        @change="handleFileUpload"
        style="display: none"
        accept="image/*"
      />
    </div>

    <span v-if="alert.error" class="text-danger">
      {{ alert.error }}
    </span>

    <b-modal
      v-model="isPreviewModalOpen"
      :title="modalTitle"
      size="sm"
      hide-footer
    >
      <ocr-preview-modal
        :imageSrc="selectedImage"
        :checklistValue="checklistValue"
        :recognizedText="previewText"
        @confirm-text="onConfirmText"
        @edit-text="openModal"
        @remove-ocr-attachment="removeOcrAttachment"
        @close="closeModal"
      />
    </b-modal>

    <b-modal
      v-model="isModalOpen"
      :title="modalTitle"
      size="lg"
      hide-footer
      @hide="closeModal"
    >
      <ocr-modal-content
        :previewText="previewText"
        :initialImage="selectedImage"
        :previousRecognizedText="recognizedText"
        :checklistValue="checklistValue"
        @text-edited="updateOcrText"
        @img-loaded="updateOcrImg"
        @close-modal="closeModal"
        @remove-ocr-attachment="removeOcrAttachment"
      />
    </b-modal>
  </div>
</template>

<script>
import OcrModalContent from "./OcrModalContent.vue";
import OcrPreviewModal from "./OcrPreviewModal.vue";
import {
  recognizeText,
  applyFormattingRules,
  extractInformation
} from "./OcrService";

export default {
  name: "OcrField",
  components: {
    OcrModalContent,
    OcrPreviewModal
  },
  props: {
    checklistValue: Object
  },
  data() {
    return {
      alert: {
        error: "",
        success: ""
      },
      modalTitle: "Reconhecimento de Texto (OCR)",
      isModalOpen: false,
      isPreviewModalOpen: false,
      selectedImage: null,
      recognizedText: null,
      previewText: null,
      base64Image: null
    };
  },
  methods: {
    openImageSelection() {
      this.clearError();
      this.$refs.fileInput.click();
    },
    openModal() {
      this.isModalOpen = true;
    },
    async handleFileUpload(event) {
      const file = event.target.files[0];
      if (file) {
        this.selectedImage = URL.createObjectURL(file);
        this.base64Image = this.selectedImage;
        this.recognizeAndPreviewText(file);
      }
      event.target.value = null;
    },
    async recognizeAndPreviewText(file) {
      const reader = new FileReader();
      const ocrFieldType = this.checklistValue.ocrType;

      reader.onloadend = async () => {
        const base64Image = reader.result.split(",")[1];
        this.base64Image = reader.result;
        try {
          const apikey = this.$store.getters.googleApiKey;
          const recognizedText = await recognizeText(base64Image, apikey);

          const formattedText = applyFormattingRules(
            recognizedText,
            ocrFieldType
          );
          this.recognizedText = formattedText;

          this.previewText = extractInformation(
            this.recognizedText,
            ocrFieldType
          );
          if (ocrFieldType == 1) {
            this.isModalOpen = true;
          } else {
            this.isPreviewModalOpen = true;
          }
        } catch (error) {
          this.alert.error =
            "Erro ao reconhecer o texto. " +
            error.code +
            ": " +
            error.response.status;
          console.error(this.alert.error);
        }
      };

      reader.readAsDataURL(file);
    },

    onConfirmText() {
      this.updateOcrImg(this.base64Image);
      this.updateOcrText(this.checklistValue);
      this.closeModal();
    },
    updateOcrText(value) {
      this.$emit("onDataChange", value);
    },
    updateOcrImg(img) {
      this.$emit("update-image-src", img);
    },
    removeOcrAttachment(fieldId) {
      this.$emit("remove-ocr-attachment", fieldId);
    },
    closeModal() {
      this.isPreviewModalOpen = false;
      this.isModalOpen = false;
    },
    clearError() {
      this.alert.error = "";
    }
  }
};
</script>

<style scoped>
.text-danger {
  color: red;
}
.ocr-container {
  display: flex;
  align-items: center;
  margin-bottom: -5px;
}
</style>
